module.exports = __webpack_public_path__ + "static/heavy_ugl5-337706e57007da93189b38112116fc1c.jpg";